import {Accordion, AccordionTab} from "primereact/accordion";
import ReportItem from "./ReportItem";
import {ReportItemData} from "../../../../types/demo";

interface Props {
    items: ReportItemData[];
    onToggleFavorite: (item: any) => void;
    isOpen: boolean;
    onToggle: (isOpen: boolean) => void;
}

const FavoriteAccordion = ({ items, onToggleFavorite, isOpen, onToggle }: Props) => {
    const mid = Math.ceil(items.length / 2);
    const left = items.slice(0, mid);
    const right = items.slice(mid);

    return (
        <Accordion
            activeIndex={isOpen ? 0 : null}
            onTabChange={(e) => onToggle(e.index === 0)}
        >
            <AccordionTab  header="Favorites">
                <div className="grid">
                    <div className="col-12 md:col-6">
                        {left.map((item) => (
                            <ReportItem key={`fav-l-${item.label}`} item={item} isFavorite={true} onToggleFavorite={onToggleFavorite} showGroup={true} />
                        ))}
                    </div>
                    <div className="col-12 md:col-6">
                        {right.map((item) => (
                            <ReportItem key={`fav-r-${item.label}`} item={item} isFavorite={true} onToggleFavorite={onToggleFavorite} showGroup={true} />
                        ))}
                    </div>
                </div>
            </AccordionTab>
        </Accordion>
    );
};

export default FavoriteAccordion;